import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99ed05b6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=99ed05b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ed05b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99ed05b6')) {
      api.createRecord('99ed05b6', component.options)
    } else {
      api.reload('99ed05b6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=99ed05b6&scoped=true", function () {
      api.rerender('99ed05b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/stock/deliver/index.vue"
export default component.exports